import { snakeCaseToTitleCase } from "components/DataIngestion/SourceDatabases/utils";

import { NON_PERCENT_STATS } from "./constants";

import { getRoundedPercent } from "../../../utils";

const getConfusionMatrixData = ({
  true_positive,
  true_negative,
  false_positive,
  false_negative,
}) => {
  const actualPositives = true_positive + false_negative;
  const actualNegatives = true_negative + false_positive;
  const total = actualPositives + actualNegatives;

  return {
    positives: {
      true: {
        count: true_positive,
        percent: getRoundedPercent(true_positive, total, 2),
      },
      false: {
        count: false_positive,
        percent: getRoundedPercent(false_positive, total, 2),
      },
      predicted: {
        count: true_positive + false_positive,
        percent: getRoundedPercent(true_positive + false_positive, total, 2),
      },
      actual: {
        count: true_positive + false_negative,
        percent: getRoundedPercent(true_positive + false_negative, total, 2),
      },
    },
    negatives: {
      true: {
        count: true_negative,
        percent: getRoundedPercent(true_negative, total, 2),
      },
      false: {
        count: false_negative,
        percent: getRoundedPercent(false_positive, total, 2),
      },
      predicted: {
        count: true_negative + false_negative,
        percent: getRoundedPercent(true_negative + false_negative, total, 2),
      },
      actual: {
        count: true_negative + false_positive,
        percent: getRoundedPercent(true_negative + false_positive, total, 2),
      },
    },
  };
};

const getModelStatisticsData = statsObj => {
  const stats = Object.entries(statsObj).reduce((acc, [key, val]) => {
    const isPercent = !NON_PERCENT_STATS.includes(key);
    const name = snakeCaseToTitleCase(key);
    const value =
      isFinite(val) && Math.floor(val) === val
        ? val
        : parseFloat(isPercent ? val * 100 : val).toFixed(2);
    return [{ key, name, value, isPercent }, ...acc];
  }, []);
  stats.sort((a, b) => a.name.localeCompare(b.name));
  return stats;
};

export { getConfusionMatrixData, getModelStatisticsData };
